import { Helmet } from 'react-helmet';
import useAuth from '../hooks/useAuth';
import React, { useState, useEffect } from 'react';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { subscriptionInfo, processPaypalPayment } from '../api';

function Payment() {
  const title = 'Payment';

  const auth = useAuth();
  const user = auth.getSession();
  const [price, setPrice] = useState(null);
  const [premium, setPremium] = useState(null);
  const [isPaid, setIsPaid] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [payments, setPayments] = useState([]);
  const [subscribe, setSubscribe] = useState("Individual");
  const [isIndividualUser, setIsIndividualUser] = useState(true);

  useEffect(() => {
    fetchSubscriptionInfo();
  }, []);

  const fetchSubscriptionInfo = async () => {
    try {
      // console.log("user:", user);

      const response = await subscriptionInfo();
      const data = response.data;
      setPrice(data.price)
      setIsPaid(data.is_paid)
      setSubscription(data.subscription)
      setPayments(data.payments)
      setPremium(data.premium)
      
      if (user.is_enterprise){
        setSubscribe("Enterprise");
        setPremium("***")
      } 
      setIsIndividualUser(!user.is_enterprise);
    } catch (error) {
      console.error('Error fetching subscription price:', error);
    }
  };

  const handleApprove = async (data, actions) => {
    try {
      const order = await actions.order.capture();
      // console.log('Payment completed', order);

      // Process payment on the backend
      const response = await processPaypalPayment({
        amount: order.purchase_units[0].amount.value,
        description: 'Subscription payment'
      });

      // console.log('Backend response:', response);

      // Refresh subscription info
      await fetchSubscriptionInfo();

      alert('Payment successful!');
    } catch (error) {
      console.error('Error processing payment:', error);
      alert('Error processing payment. Please try again.');
    }
  };

  if (price === null) {
    return <div>Loading...</div>;
  }
  // "client-id": "AUKO6ASU7uk91XaJlNcibCSWYONNg6JYY7mPniEMWquFYGv1ybQtgGn14tZVrsJgESG0TUOuyT2xzz1Y" --pharm
  // "client-id": "AcYt-NdmjhXt6fR_cV2WRSNaVp_73JmvI68dRZ8uowlm3VObGL9Re1_pzh0JytMW_4E38BZ_nB5DvBbS"   -accesseva

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className="container mt-2 mb-5 py-sm-7">

        <div className="row g-4 align-content-center" style={{ maxWidth: '60rem', marginTop: '20px;' }}>
          <div className="col-12">
            <div className="card mb-3">
              <div className="card-header bg-white">
                <h4 className="text-primary">Subscription for an {subscribe} User</h4>
              </div>
              <div className="card-body">
                <h5 data-v-fead788c="" className="my-2 text-primary">{subscribe} Plan</h5>

                <ul>
                  {isIndividualUser && (<li>Annual Subscription&nbsp; ${premium}, as a one-time payment, in advance, in full</li>)}
                  <li>Your Annual Subscription as an {subscribe} User is subject to the Privacy Policy and the Terms of Service</li>
                  {isIndividualUser && (<li>Your Annual Subscription is subject to automatic renewal unless your Account is terminated in advance</li>)}
                </ul>

              </div>
            </div>

          </div>
          <div className="col-12">
            <div className="card mb-3">
              <div className="card-header bg-white">
                <h4 className="text-primary">Payment of Annual Subscription for {subscribe} Account</h4>
              </div>
              <div className="card-body">
                {isPaid ? (
                  <p>Your annual subscription for ${premium} has been successfully processed. Your subscription is now active.</p>
                ) : (
                  <>
                    <h5>Payment Details: ${price} (One-Time) Annual Subscription Fee </h5>

                    <PayPalScriptProvider options={{ "client-id": "AcYt-NdmjhXt6fR_cV2WRSNaVp_73JmvI68dRZ8uowlm3VObGL9Re1_pzh0JytMW_4E38BZ_nB5DvBbS" }}>
                      <PayPalButtons
                        createOrder={(data, actions) => {
                          return actions.order.create({
                            purchase_units: [
                              {
                                amount: {
                                  value: price,
                                },
                              },
                            ],
                          });
                        }}
                        onApprove={handleApprove}
                      />
                    </PayPalScriptProvider>
                  </>
                )}
                {subscription && Object.keys(subscription).length > 0 && (
                  <div className="mt-4">
                    <h2>Current Subscription</h2>
                    {subscription.type && <p>Type: {subscription.type}</p>}
                    {subscription.startDate && (
                      <p>Start Date: {new Date(subscription.startDate).toLocaleDateString()}</p>
                    )}
                    {subscription.endDate && (
                      <p>End Date: {new Date(subscription.endDate).toLocaleDateString()}</p>
                    )}
                  </div>
                )}

              </div>
            </div>
          </div>
          <div className="col-12">
            {payments && payments.length > 0 && (
              <div className="card mb-3">

                <div className="card-header bg-white">
                  <h4 className="text-primary">Payment History</h4>
                </div>
                <div className="card-body">

                  <ul>
                    {payments.map((payment, index) => (
                      <li key={index}>
                        {payment.type} - ${payment.paidAmount} on {new Date(payment.datePaid).toLocaleDateString()}
                      </li>
                    ))}
                  </ul>

                </div>
              </div>
            )}
          </div>

        </div>


      </div>
    </>
  );
}

export default Payment;
